import { create } from 'zustand';

import type { AppliedCalculatedFrequency, FrequencyRecommendation } from './frequencyRecommendation';

type State = {
    isOpen: boolean;
    calculationResult: FrequencyRecommendation | null;
    appliedFrequency: AppliedCalculatedFrequency | null;
    open: () => void;
    close: () => void;
    setCalculationResult: (result: FrequencyRecommendation) => void;
    clearCalculationResult: () => void;
    setAppliedFrequency: (applied: AppliedCalculatedFrequency) => void;
    clearAppliedFrequency: () => void;
};

export const useFrequencyCalculatorDrawerStore = create<State>()(set => ({
    isOpen: false,
    calculationResult: null,
    appliedFrequency: null,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    setCalculationResult: result => set({ calculationResult: result }),
    clearCalculationResult: () => set({ calculationResult: null }),
    setAppliedFrequency: applied => set({ appliedFrequency: applied }),
    clearAppliedFrequency: () => set({ appliedFrequency: null }),
}));
